import { SVGProps, Ref, forwardRef } from 'react';

export const GlobeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.058 11.1h5.884c-.052-2.796-.35-5.426-.95-7.368-.334-1.079-.722-1.812-1.102-2.247C12.55 1.095 12.272 1 12 1c-.273 0-.549.095-.89.485-.38.435-.768 1.168-1.101 2.247-.6 1.941-.899 4.572-.95 7.368m5.884 1.8c-.052 2.796-.35 5.426-.95 7.368-.334 1.079-.722 1.813-1.102 2.247-.341.39-.618.485-.89.485-.273 0-.549-.095-.89-.485-.38-.434-.768-1.168-1.101-2.247-.6-1.942-.899-4.572-.95-7.368zm1.8 0h6.233c-.252 4.48-2.44 8.761-8.066 9.84 1.24-2.227 1.764-5.978 1.833-9.84m6.233-1.8c-.252-4.48-2.44-8.761-8.066-9.84 1.24 2.227 1.764 5.979 1.833 9.84zm-15.717 0H1.025c.252-4.48 2.44-8.761 8.066-9.84-1.24 2.227-1.764 5.979-1.833 9.84m0 1.8H1.025c.252 4.48 2.44 8.761 8.066 9.84-1.24-2.227-1.764-5.978-1.833-9.84"
                fill="currentColor"
            />
        </g>
    </svg>
));
GlobeFilledSize24Glyph.displayName = 'GlobeFilledSize24Glyph';
